module.exports = __webpack_public_path__ + "img/nike.7f01d224.svg";